/**
 * PV EA Bundle Card — campaign prices
 * When the Froya campaign engine has a first-order price for the bundle
 * variant (assets/pv-ea-campaign.js), re-render the price, both "SAVE x%"
 * labels and the "You save $x" line from it, with the section's Liquid math:
 *   save %   = (compare incl. gift - price) / compare, rounded down
 *   savings  = bundle compare-at - price, whole dollars rounded down
 * No campaign price: the Liquid values come back.
 */

(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var price = root.querySelector('[data-pv-ea-bundle-price]');
    var saves = root.querySelectorAll('[data-pv-ea-bundle-save]');
    // One savings node per copy variant (desktop / optional mobile); each
    // carries its own template in data-pv-ea-bundle-savings.
    var savings = root.querySelectorAll('[data-pv-ea-bundle-savings]');
    var original = {
      price: price && price.textContent,
      saves: Array.prototype.map.call(saves, function (el) { return el.textContent; }),
      savings: Array.prototype.map.call(savings, function (el) { return el.textContent; })
    };

    var compare = parseInt(root.dataset.compare, 10) || 0;
    var compareBase = parseInt(root.dataset.compareBase, 10) || 0;

    function restore() {
      if (price) price.textContent = original.price;
      saves.forEach(function (el, i) { el.textContent = original.saves[i]; });
      savings.forEach(function (el, i) { el.textContent = original.savings[i]; });
    }

    function update() {
      PVEaCampaign.price(root.dataset.variant, root.dataset.handle, root.dataset.kind).then(function (now) {
        if (now == null) {
          restore();
          return;
        }
        var pct = compare > now ? Math.floor(((compare - now) * 100) / compare) : 0;
        var saved = Math.max(0, Math.floor((compareBase - now) / 100) * 100);
        var pctText = String(pct);
        var savedText = PVEaCampaign.money(saved, true);

        if (price) price.textContent = PVEaCampaign.money(now, false);
        if (pct > 0) {
          saves.forEach(function (el) {
            el.textContent = (root.dataset.saveLabel || '').replace('{percent}', pctText);
          });
        }
        if (saved > 0) {
          savings.forEach(function (el) {
            el.textContent = (el.getAttribute('data-pv-ea-bundle-savings') || root.dataset.savingsText || '')
              .replace('{savings}', savedText)
              .replace('{gift_value}', root.dataset.giftValue || '')
              .replace('{percent}', pctText);
          });
        }
      });
    }

    PVEaCampaign.watch(update);
  }

  function initAll(scope) {
    if (!window.PVEaCampaign) return;
    (scope || document).querySelectorAll('[data-pv-ea-bundle]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
